import React from "react";
import RecordDesktopRenderer from "./RecordsViewRenderer/Desktop/RecordDesktopRenderer";

const MapsViewRenderer = ({ applicationBlockData, handleSaveApplicationBlock, handleCloneApplicationBlock }) => {
  if (applicationBlockData.device === "mobile") {
    return (
      <RecordDesktopRenderer
        applicationBlockData={applicationBlockData}
        handleSaveApplicationBlock={handleSaveApplicationBlock}
        handleCloneApplicationBlock={handleCloneApplicationBlock}
        isMapBlock={true}
      />
    );
  }
  if (applicationBlockData.device === "desktop" || applicationBlockData.device === "tablet") {
    return (
      <RecordDesktopRenderer
        applicationBlockData={applicationBlockData}
        handleSaveApplicationBlock={handleSaveApplicationBlock}
        handleCloneApplicationBlock={handleCloneApplicationBlock}
        isMapBlock={true}
      />
    );
  }
};

export default MapsViewRenderer;
